<app-infobox-table [data]="computeInfoboxEntries()!"></app-infobox-table>
